import * as myxhr from "./myxhr.js";

export function get() {
    return myxhr.get('/assessmentlatest', { headers: { 'Accept': 'application/json'} });
}

export function getImage() {
    return myxhr.get('/assessmentlatest', { headers: { 'Accept': 'image/png'}, responseType: 'blob' });
}